import React from "react";
import { updateNFeStatus } from "../../../../../../api/nfe";
import { showSnackBar } from "../../../../../../utils";
import Button from "../../../../../../_components/Button";
import Modal from "../../../../../../_components/Modal";

export default (props) => {
  const [loading, setLoading] = React.useState(false);
  function onUpdate() {
    setLoading(true);
    updateNFeStatus(props.nfe.id)
      .then((resp) => {
        showSnackBar("O status da NF-e foi atualizado!", "info");
        if (props.onFinally) {
          props.onFinally();
        }
      })
      .catch((error) => {
        if (error.error) {
          showSnackBar(error.error);
        }
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }
  return (
    <React.Fragment>
      <Button
        disabled={loading}
        as="text"
        className="text-info mx-1"
        title="Consultar NF-e na SEFAZ"
        onClick={onUpdate}
      >
        <i className="fas fa-sync-alt" /> <span>Consultar NF-e na SEFAZ</span>
      </Button>
      <Modal title="Consultando NF-e ..." show={loading} onHide={() => {}} />
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/Actions/UpdateStatus/index.jsx